import { render, staticRenderFns } from "./delivery-status.vue?vue&type=template&id=00b48c23"
import script from "./delivery-status.vue?vue&type=script&lang=js"
export * from "./delivery-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports